var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeballOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.504,
    height: 16.714,
    viewBox: "0 0 19.504 16.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-eye-off",
    d: "M12,8.017a4.421,4.421,0,0,1,4.435,4.4,4.233,4.233,0,0,1-.318,1.61l2.59,2.568a10.405,10.405,0,0,0,3.042-4.178A10.5,10.5,0,0,0,8.465,6.433l1.915,1.9A4.385,4.385,0,0,1,12,8.017Zm-8.866-2.4L5.162,7.625l.409.4A10.355,10.355,0,0,0,2.25,12.417a10.519,10.519,0,0,0,13.636,5.858l.374.37,2.6,2.568L19.987,20.1,4.261,4.5Zm4.9,4.862,1.375,1.362a2.493,2.493,0,0,0-.07.57A2.646,2.646,0,0,0,12,15.051a2.5,2.5,0,0,0,.575-.07l1.375,1.362a4.412,4.412,0,0,1-6.385-3.935A4.348,4.348,0,0,1,8.039,10.48ZM11.86,9.8l2.794,2.773.017-.139a2.646,2.646,0,0,0-2.659-2.638Z",
    transform: "translate(-2.25 -4.5)",
    fill: "#21409a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeballOff);
export default __webpack_public_path__ + "static/media/eyeball_off.4812f0e260748d43ffcf2c36ce851244.svg";
export { ForwardRef as ReactComponent };